// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".billing-settings .briq-form-element,\n.billing-settings h2 {\n  margin-bottom: 24px;\n}\n.billing-settings .form-groups {\n  margin-bottom: 0;\n}\n.billing-settings .briq-form-element li {\n  margin-left: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
